import { render, staticRenderFns } from "./DeleteSiteDialog.vue?vue&type=template&id=780d8f38&scoped=true"
import script from "./DeleteSiteDialog.vue?vue&type=script&lang=js"
export * from "./DeleteSiteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780d8f38",
  null
  
)

export default component.exports